import * as React from 'react';
import { SVGProps } from 'react';

const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 12V9l-6 5-6-5v3l6 5 6-5z" />
  </svg>
);

export default SvgChevronDown;
